import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import FullScreenNav from "./FullScreenNav";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

function Header() {
  const location = useLocation();
  const { user, logout } = useAuth();
  const [isNavVisible, setIsNavVisible] = useState(false);
  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
  };

  return (
    <header className="relative z-50 flex justify-between items-center bg-background p-4">
      <Link to="/" className="font-bold text-2xl text-primary">
        RealignMind
      </Link>

      {/* Hamburger Menu Button */}
      <button
        onClick={toggleNav}
        className="flex items-center justify-center md:hidden focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2"
        aria-label="Toggle navigation"
      >
        {isNavVisible ? (
          <XMarkIcon className="h-8 w-8 text-text" />
        ) : (
          <Bars3Icon className="h-8 w-8 text-accent" />
        )}
      </button>

      {/* FullScreenNav Component */}
      <FullScreenNav isVisible={isNavVisible} closeNav={toggleNav} />

      {/* Desktop Navigation Menu */}
      <nav className="hidden md:flex">
        <ul className="flex space-x-5 items-center">
          {!user && (
            <li>
              <Link
                to="/try"
                state={{ from: location.pathname }}
                className="bg-accent hover:bg-accentDark text-white font-semibold py-2 px-4 rounded-full transition-colors text-sm focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2"
              >
                Try a full session
              </Link>
            </li>
          )}
          <li className="relative group z-50">
            <button className="text-secondary hover:text-accent transition-colors flex items-center gap-1 focus-visible:outline-2 focus-visible:outline-primary/30 focus-visible:outline-offset-2">
              Learn <span className="text-xs">▼</span>
            </button>
            <ul className="absolute left-0 bg-background border border-tint rounded shadow-sm hidden group-hover:block z-50 min-w-[200px]">
              <li>
                <Link
                  to="/demo"
                  className="block px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                >
                  Watch the demo
                </Link>
              </li>
              <li>
                <Link
                  to="/what-is-bilateral-stimulation"
                  className="block px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                >
                  What is Bilateral Stimulation?
                </Link>
              </li>
              <li>
                <Link
                  to="/how-it-works"
                  className="block px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                >
                  The Science
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="block px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <a
                  href="https://blog.realignmind.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                >
                  Blog
                </a>
              </li>
            </ul>
          </li>
          {!user && (
            <>
              <li>
                <Link
                  to="/login"
                  state={{ mode: "register" }}
                  className="text-secondary hover:text-accent transition-colors"
                >
                  Sign up free
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-textSecondary hover:text-accent transition-colors">
                  Login
                </Link>
              </li>
            </>
          )}
          {user && (
            <>
              <li>
                <Link
                  to="/sessions"
                  className="text-secondary hover:text-accent transition-colors"
                >
                  Bilateral Stimulation Session
                </Link>
              </li>
              <li className="relative group z-50">
                <Link to="/profile" className="text-secondary hover:text-accent transition-colors">
                  Profile <span className="inline">▼</span>
                </Link>
                <ul className="absolute right-0 bg-background border border-tint rounded shadow-sm hidden group-hover:block z-50">
                  <li>
                    <Link
                      to="/profile"
                      className="block px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                    >
                      Profile
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/session-history"
                      className="block px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                    >
                      Session History
                    </Link>
                  </li>
                  <li>
                    <button
                      onClick={logout}
                      className="block w-full text-left px-4 py-2 text-secondary hover:text-white hover:bg-accent transition-colors"
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            </>
          )}
        </ul>
      </nav>
    </header>
  );
}

export default Header;
